import { Show } from "solid-js";
import { Title } from "@solidjs/meta";
import { Banner } from "~/common/banner";
import { Button } from "~/common/button";
import { Form, InputField } from "~/common/form";
import { useForm } from "~/inertia";
import { newUserConfirmationPath, userPasswordPath } from "~/routes";
import { AuthPageLayout, AuthPageLink } from "./_layout";

type Props = {
  resetPasswordToken: string;
  strings: {
    title: string;
    newPasswordLabel: string;
    confirmPasswordLabel: string;
    passwordHint: string | null;
    submit: string;
    resendConfirmation: string;
  };
};

export default function ChangePassword(props: Props) {
  const form = useForm({
    // eslint-disable-next-line solid/reactivity -- token is fixed for the page's lifetime
    resetPasswordToken: props.resetPasswordToken,
    password: "",
    passwordConfirmation: "",
  }).transform((data) => ({ user: data }));

  return (
    <AuthPageLayout>
      <Title>{props.strings.title}</Title>

      <h1 class="text-2xl font-semibold">{props.strings.title}</h1>

      <Form
        class="space-y-6"
        onSubmit={(e) => {
          e.preventDefault();
          form.put(userPasswordPath());
        }}
      >
        <Show when={form.errors.resetPasswordToken?.length}>
          <Banner variant="error" description={form.errors.resetPasswordToken!.join(", ")} />
        </Show>

        <InputField
          label={props.strings.newPasswordLabel}
          type="password"
          required
          autofocus
          autocomplete="new-password"
          description={props.strings.passwordHint ?? undefined}
          value={form.data.password}
          errors={form.errors.password}
          onChange={(e) => form.setData("password", e.target.value)}
        />

        <InputField
          label={props.strings.confirmPasswordLabel}
          type="password"
          required
          autocomplete="new-password"
          value={form.data.passwordConfirmation}
          errors={form.errors.passwordConfirmation}
          onChange={(e) => form.setData("passwordConfirmation", e.target.value)}
        />

        <Button
          type="submit"
          variant="primary"
          size="lg"
          width="full"
          class="mt-12"
          loading={form.processing}
        >
          {props.strings.submit}
        </Button>
      </Form>

      <AuthPageLink href={newUserConfirmationPath()}>
        {props.strings.resendConfirmation}
      </AuthPageLink>
    </AuthPageLayout>
  );
}
